module.exports = "https://s81616.cdn.ngenix.net/home-frontend/_next/static/images/img-f9f49f53a5ce681c7ae1006e2f64d41e.png";